import api from '../../utils/api';
import { getRetailerStores, getUsers } from './api/retailers';
import { alertError, alertSuccess } from './alert';
import {
  ADMIN_STORES,
  ADMIN_STORES_USERS,
  ADMIN_STORES_LOADING,
  ADMIN_STORES_UPDATING_USERS,
} from '../constants/adminStoresTypes';

const setAdminStores = (data) => ({ type: ADMIN_STORES, payload: data });
const setAdminStoresLoading = (value) => ({ type: ADMIN_STORES_LOADING, payload: value });
export const setAdminStoresUsers = (value) => ({ type: ADMIN_STORES_USERS, payload: value });
export const adminStoresUpdatingUserStores = (value) => ({ type: ADMIN_STORES_UPDATING_USERS, payload: value });

export const getAdminStores =
  (showLoading = true) =>
  async (dispatch, getState) => {
    try {
      if (showLoading) {
        dispatch(setAdminStoresLoading(true));
      }

      const { retailerId } = getState().role;
      const storesResponse = await getRetailerStores(retailerId);
      dispatch(setAdminStores(storesResponse.data));

      const usersResponse = await getUsers(retailerId);
      dispatch(setAdminStoresUsers(usersResponse.data.filter((x) => x.user !== null)));
    } catch (error) {
      dispatch(alertError(error));
    } finally {
      if (showLoading) {
        dispatch(setAdminStoresLoading(false));
      }
    }
  };

export const putAdminStores = (storeId, data) => async (dispatch, getState) => {
  try {
    const { retailerId } = getState().role;
    const response = await putStores(retailerId, storeId, data);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }

    dispatch(getAdminStores(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const postAdminUserStores = (storeId, id) => async (dispatch, getState) => {
  try {
    dispatch(adminStoresUpdatingUserStores(id));

    const { retailerId } = getState().role;
    const response = await postUserStores(retailerId, storeId, {
      user_id: id,
    });

    if (response.data.id) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }

    dispatch(getAdminStores(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const postAdminStores = (data) => async (dispatch, getState) => {
  try {
    const { retailerId } = getState().role;
    const response = await postStores(retailerId, data);

    if (response.data.id) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }

    dispatch(getAdminStores(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const deleteAdminUserStores = (storeId, id) => async (dispatch, getState) => {
  try {
    dispatch(adminStoresUpdatingUserStores(id));

    const { retailerId } = getState().role;
    const response = await deleteUserStores(retailerId, storeId, id);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }

    dispatch(getAdminStores(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const deleteUserStore = (storeId) => async (dispatch, getState) => {
  try {
    const { retailerId } = getState().role;
    const response = await deleteStore(retailerId, storeId);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
    } else {
      dispatch(alertError('Error'));
    }

    dispatch(getAdminStores(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

let cancelPutStores;
const putStores = (retailerId, storeId, data) => {
  if (cancelPutStores) {
    cancelPutStores('Cancel put store');
  }

  return api.put(`/retailers/${retailerId}/stores/${storeId}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutStores = c)),
  });
};

let cancelPostStores;
const postStores = (retailerId, data) => {
  if (cancelPostStores) {
    cancelPostStores('Cancel post store');
  }

  return api.post(`/retailers/${retailerId}/stores`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPostStores = c)),
  });
};

let cancelDeleteStores;
const deleteStore = (retailerId, storeId) => {
  if (cancelDeleteStores) {
    cancelDeleteStores('Cancel delete store');
  }

  return api.delete(`/retailers/${retailerId}/stores/${storeId}`, {
    cancelToken: new api.CancelToken((c) => (cancelDeleteStores = c)),
  });
};

const postUserStores = (retailerId, storeId, data) => {
  return api.post(`/retailers/${retailerId}/stores/${storeId}/users`, data);
};

const deleteUserStores = (retailerId, storeId, userId) => {
  return api.delete(`/retailers/${retailerId}/stores/${storeId}/users/${userId}`);
};
